/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_User_LabelInputs */

const es_tyc_definitions_user_label = /** @type {(inputs: Tyc_Definitions_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario`)
};

const en_tyc_definitions_user_label = /** @type {(inputs: Tyc_Definitions_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Tyc_Definitions_User_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_user_label = /** @type {((inputs?: Tyc_Definitions_User_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_User_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_user_label(inputs)
	return en_tyc_definitions_user_label(inputs)
});
export { tyc_definitions_user_label as "tyc.definitions.user_label" }